<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {}
  },
  watch: {
    $route(to) {
      this.$store.commit('setDicFlags', {})
      this.checkServiceDictionary()
    },
  },
  methods: {},
}
</script>
<style scoped>
#app {
  height: 100%;
}
</style>
